// removed by extract-text-webpack-plugin
module.exports = {"root":"TopRefs-module-root-1YpkD","section":"TopRefs-module-section-2PoVG","listing":"TopRefs-module-listing-3v-m1","section-title":"TopRefs-module-section-title-3JM4H","sectionTitle":"TopRefs-module-section-title-3JM4H","icon-arrow":"TopRefs-module-icon-arrow-17dsl","iconArrow":"TopRefs-module-icon-arrow-17dsl"};


//////////////////
// WEBPACK FOOTER
// ./src/components/TopRefs/TopRefs.module.scss
// module id = 1108
// module chunks = 0